<template>
    <div class="row">
        <div class="col-md-12 card-wrapper">
            <div class="card">
                <div class="card-header crm-modal-header hpx-50 d-flex align-items-center">{{$ml.get('CHANGE_PASSWORD')}}</div>
                <div class="card-body bg-light color-gray">
                    <div class="row d-flex justify-content-center">
                        <div class="col-md-8">
                            <div class="form-group row">
                                <label class="new-label col-md-4">{{$ml.get('CURRENT_PASSWORD')}} *</label>
                                <div class="col-md-8">
                                    <input type="password" v-model="oldPassword" class="new-input" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="new-label col-md-4">{{$ml.get('NEW_PASSWORD')}} *</label>
                                <div class="col-md-8">
                                    <input type="password" v-model="password" class="new-input" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="new-label col-md-4">{{$ml.get('NEW_PASSWORD_CONFIRM')}} *</label>
                                <div class="col-md-8">
                                    <input type="password" v-model="rePassword" class="new-input" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer crm-modal-footer text-right">
                    <button class="btn " @click="resetForm()">{{$ml.get('CANCEL')}}</button>
                    <button class="btn bg-new-primary w-150p " @click="changePasswordF()">{{$ml.get('SAVE')}}</button>
                </div>
            </div>
        </div>
        <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    name:'changePassword',
    data() {
        return {
            password:'',
            oldPassword:'',
            rePassword:''
        }
    },
    methods: {
        ...mapActions(['changePassword']),
        resetForm(){
            this.password=''
            this.oldPassword=''
            this.rePassword=''
        },
        changePasswordF(){
            let form = {}

            if(this.password=='' || this.oldPassword=='' || this.rePassword==''){
                this.$notify({ 
                    group: 'foo',
                    type: 'warning', 
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('PLEASE_FILL_ALL_THE_FIELDS_*') 
                })
                return false
            }else if(this.rePassword!==this.password){
                this.$notify({ 
                    group: 'foo',
                    type: 'warning', 
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('PASSWORDS_SHOULD_MATCH') 
                })
                return false
            }else{
                 form.rePassword= this.rePassword
                 form.oldPassword= this.oldPassword
                 form.password= this.password
            }
            
            this.changePassword(form).then((res)=>{return res}).then((res)=>{
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESSFUL'),
                        text: this.$ml.get('CHANGE_PASSWORD_SUCCESSFUL') 
                    })
                    if(res.data.content.user.language){
                        this.$ml.change(res.data.content.user.language);
                    }
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                }
            })
        }
        
    }
}
</script>